import React, { forwardRef,useImperativeHandle,useRef,useEffect } from "react";
import ComponentTagSelector from "../tags/ComponentTagSelector";
// import { usePropertyTypes } from "../../context/PropertyTypeContext.jsx";

import { useMasterData } from "../../context/MasterDataContext.jsx";    


const Comp_PropertyType = forwardRef(({
    maxTags = undefined,
    // style='',
    style={},        // container style
    tagStyle={},  // tags
    inputStyle={}, // input field



    // defaultTags = [],
    selectedTags = [],
    setSelectedTags = () => {},

    onPropertyTypeSelect,
    onPropertyTypeRemove,
    onPropertyTypeChangeTag,
}, ref) => {
    const placeHolder = "Select Property Type";
    // const masterPropertyType = usePropertyTypes(); // Assuming this returns the list of property types
    // const {propertytypes:masterPropertyType,ready:propertytypeReady}=usePropertyTypes();

    // console.log("selectedTags: Property Type: ", selectedTags);

    const {propertyTypes:masterPropertyType,propertyTypesReady:propertytypeReady}= useMasterData();
    



    const tagrefPropType = useRef(null);
     // Apply defaultTags when they change
    //  useEffect(() => {
    //     if (defaultTags && defaultTags.length > 0) {
    //         tagrefPropType.current.setTags(defaultTags); // Explicitly set defaultTags
    //         // console.log("Default tags applied:", defaultTags);
    //     }
    // }, [defaultTags]);
        const hasInitialized = useRef(false);




    /**
     * Resolve property type IDs or mixed tags into full objects from masterPropertyType
     * @param {Array<number|string|object>} idsOrObjects
     * @returns {Array<object>}
     */
    const getObjectFromIds = (idsOrObjects) => {
        // console.log("controlPropertyType: getting ids for returning objec",idsOrObjects)

        if (!Array.isArray(idsOrObjects) || !Array.isArray(masterPropertyType)) return [];
        return idsOrObjects
            .map(tagOrId => {
                if (tagOrId && typeof tagOrId === 'object' && 'id' in tagOrId && 'propertytype' in tagOrId) {
                    return tagOrId;
                }
                const rawId = typeof tagOrId === 'string' && /^\d+$/.test(tagOrId)
                    ? parseInt(tagOrId, 10)
                    : tagOrId;

                return masterPropertyType.find(tt => {
                    const tid = tt.id;
                    return (typeof tid === 'number' && tid === rawId) ||
                           (typeof tid === 'string' && tid === ('' + rawId));
                });
            })
            .filter(Boolean)
            .map(pt => ({ ...pt, status: 'default' }));
    };














        // useEffect(() => {
        //     if (
        //         !hasInitialized.current && 
        //         Array.isArray(defaultTags) &&
        //         defaultTags.length > 0 &&
        //         tagrefPropType.current &&
        //         propertytypeReady &&
        //         Array.isArray(masterPropertyType) &&
        //         masterPropertyType.length > 0
        //         ) {
        //         tagrefPropType.current.setTags(defaultTags);
        //         hasInitialized.current = true;
        //         // console.log("✅ setTags called with:", defaultTags);
        //     }
        //     {
        //     const initialTags = getObjectFromIds(defaultTags);
        //     tagrefPropType.current.setTags(initialTags);
        //     hasInitialized.current = true;
        // }
        // }, [defaultTags?.length,masterPropertyType,propertytypeReady]);



        useEffect(() => {
            if (
                // !hasInitialized.current &&
                // Array.isArray(defaultTags) &&
                // defaultTags.length > 0 &&
                // tagrefPropType.current &&
                propertytypeReady 
                // Array.isArray(masterPropertyType) &&
                // masterPropertyType.length > 0
            ) {
                const initialTags = getObjectFromIds(selectedTags);
                tagrefPropType.current.setTags(initialTags);
                hasInitialized.current = true;
            }
        }, [ propertytypeReady, masterPropertyType]);



    // console.log("Property Types: " +masterPropertyType);

    const handleSelectTag = (tag) => {
        if (onPropertyTypeSelect) {
            onPropertyTypeSelect(tag);
        }

    };

    const handleRemoveTag = (tag) => {
        if (onPropertyTypeRemove) {
            onPropertyTypeRemove(tag);
        }
    };

    const handleChangeTag = (AllTags) => {
        if (onPropertyTypeChangeTag) {
            onPropertyTypeChangeTag(AllTags);
        }
    };

    // Expose methods using ref
    useImperativeHandle(ref, () => ({
        // getPropertyTypeTags: () => tagrefPropType.current.getTags(),
        // setPropertyTypeTags: (selected) => tagrefPropType.current.setTags(selected)
        getObjectFromIds,
        getPropertyTypeTags: () => selectedTags,
        setPropertyTypeTags: (tags) => setSelectedTags(tags),

    }));
    



    return (
        <div>
            <ComponentTagSelector
                ref={tagrefPropType}
                // style={style}

                style={style}        // container style
                tagStyle={tagStyle}  // tags
                inputStyle={inputStyle} // input field

                suggestions={masterPropertyType}
                // defaultTags={defaultTags}
                maxTags={maxTags}
                selectedTags={selectedTags}
                setSelectedTags={setSelectedTags}

                // if nothing is specified then unlimited, else 1 even if 10 is defined
                displayKey="propertytype"
                allowFreeAdd={false}
                placeHolder={placeHolder}
                onSelectTag={handleSelectTag} // Pass the function correctly
                onRemoveTag={handleRemoveTag}
                onChangeTag={handleChangeTag}
            />
        </div>
    );
});

export default Comp_PropertyType;
